/* Import centralized theme variables */
@import '../../shared-design/theme.css';

html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden;
}

body {
  font-family: var(--font-primary);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--color-bg-primary);
  color: var(--color-text-primary);
  line-height: var(--line-height-body);
  font-size: var(--font-size-lg);
  letter-spacing: var(--letter-spacing-normal);
}

code {
  font-family: var(--font-code);
}

* {
  box-sizing: border-box;
}

/* Scrollbar styling */
::-webkit-scrollbar {
  width: var(--spacing-4);
}

::-webkit-scrollbar-track {
  background: var(--color-gray-scrollbar-track);
  border-radius: var(--radius-sm);
}

::-webkit-scrollbar-thumb {
  background: var(--color-gray-scrollbar-thumb);
  border-radius: var(--radius-sm);
}

::-webkit-scrollbar-thumb:hover {
  background: var(--color-gray-scrollbar-hover);
}

/* Typography Classes */
h1 {
  font-family: var(--font-headings);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-4xl);
  line-height: var(--line-height-tight);
  letter-spacing: var(--letter-spacing-normal);
  color: var(--color-heading);
}

h2 {
  font-family: var(--font-headings);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-3xl);
  line-height: var(--line-height-snug);
  letter-spacing: var(--letter-spacing-normal);
  color: var(--color-heading);
}

h3 {
  font-family: var(--font-headings);
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-2xl);
  line-height: var(--line-height-normal);
  letter-spacing: var(--letter-spacing-normal);
  color: var(--color-heading);
}

.small-ul-1 {
  font-family: var(--font-primary);
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-md);
  line-height: var(--line-height-relaxed);
  letter-spacing: var(--letter-spacing-wide);
  color: var(--color-text-primary);
}

.small-ul-2 {
  font-family: var(--font-primary);
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-base);
  line-height: var(--line-height-relaxed);
  letter-spacing: var(--letter-spacing-normal);
  color: var(--color-text-primary);
}

/* Focus styles for accessibility */
*:focus {
  outline: 2px solid var(--color-primary);
  outline-offset: var(--spacing-1);
}

/* Button reset */
button {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

/* Input reset */
input, textarea, select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}
